import React from "react";

// Auto-detect URLs in plain forum text and render them as clickable links, preserving all other
// text (parent keeps whitespace-pre-wrap so newlines/spacing survive). One capturing group means
// String.split alternates [text, url, text, url, ...].
const URL_RE = /((?:https?:\/\/|www\.)[^\s<]+[^\s<.,;:!?)\]}'"])/gi;

export function Linkify({ text, linkStyle }) {
  if (!text) return null;
  const parts = String(text).split(URL_RE);
  return (
    <>
      {parts.map((part, i) => {
        if (i % 2 === 1) {
          const href = part.startsWith("http") ? part : `https://${part}`;
          return (
            <a
              key={i}
              href={href}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="underline break-all hover:opacity-80 transition-opacity"
              style={linkStyle}
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </a>
          );
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </>
  );
}
